// Copyright (c) 2022, Comsearch, Inc., All rights reserved

import moment from 'moment-timezone'
import applicationIsWithinMaintenanceMode from './applicationIsWithinMaintenanceMode'
import { SYSTEM_MAINTENANCE_END_HOUR } from 'Routes/SystemMaintenanceCheck/constants'

/**
 * takes Moment instance, return milliseconds until maintenance window ends. <br />
 * throws if currentMomentInEastern is outside Maintenance Window
 * @param {moment.Moment} currentMomentInEastern
 * @returns {number}
 */
const getTimeUntilMaintenanceEnds = currentMomentInEastern => {
  if (!applicationIsWithinMaintenanceMode(currentMomentInEastern)) {
    throw new Error('Error: getTimeUntilMaintenanceEnds was called outside of the maintenance window')
  }

  const maintenanceWindowEnd = moment(currentMomentInEastern)
    .set('hour', SYSTEM_MAINTENANCE_END_HOUR)
    .set('minute', 0)
    .set('second', 0)
    .set('millisecond', 0)
    .valueOf()

  // delete current time's valueOf so we only give remaining time.
  return maintenanceWindowEnd - currentMomentInEastern.valueOf()
}

export default getTimeUntilMaintenanceEnds
